import React, { ReactNode } from 'react';
import TcImage from './TcImage';

function TcCard({
    classNameStyle = "", 
    cardTitle = "", 
    cardContent = "",
    cardImage = "",
    children = null
}: {
    readonly classNameStyle?: string;
    readonly cardTitle?: string;
    readonly cardContent?: string;
    readonly cardImage?: string;
    readonly children?: ReactNode;
}) {
    return (
        <div className={`relative px-8 py-4 mx-auto max-w-xl w-full h-auto ${classNameStyle}`}>
            {cardTitle && 
            <h2
                className="mt-1 mb-4 leading-7"
                dangerouslySetInnerHTML={{ __html: cardTitle }}
            />}

            {cardContent && 
            <div className="min-h-10">
                <p
                    className="text-xl leading-tight"
                    dangerouslySetInnerHTML={{ __html: cardContent }}
                />
            </div>}

            {cardImage && 
            <TcImage classNameStyle="mt-6">
                <img src={cardImage} alt={cardTitle} />
            </TcImage>}

            {children}
        </div>
    )
}

export default TcCard;